let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("dGTW6")).then(() => parcelRequire('bBrnx'));